import { render, staticRenderFns } from "./AnatomiasFisiologiasCriar.vue?vue&type=template&id=148d0798"
import script from "./AnatomiasFisiologiasCriar.vue?vue&type=script&lang=js"
export * from "./AnatomiasFisiologiasCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports